import React from "react";
import {
  getLastMessageSnippet,
  getLastMessageTimestamp,
} from "./utils/ChatUtils";

const OnlineChatList = ({ chats, activeChat, handleChatSelect }) => {
  return (
    <div className="chat-list">
      {chats.map((propertyChats, propertyIndex) => {
        // Sort users by userType (staff first, then tenants)
        const staffUsers = propertyChats.users.filter(
          (chat) => chat.userType === "staff" || !chat.userType
        );
        const tenantUsers = propertyChats.users.filter(
          (chat) => chat.userType === "tenant"
        );
        const noUsers = propertyChats.users.filter((chat) => chat.isPlaceholder);

        return (
          <div key={propertyIndex} className="property-chat-section">
            {/* Property divider/header */}
            <div className="property-divider">
              <h3>{propertyChats.propertyName}</h3>
            </div>

            {/* Staff/Role takers section */}
            {staffUsers.length > 0 && (
              <div className="user-group">
                <div className="group-label">Staff</div>
                {staffUsers.map((chat, chatIndex) => (
                  <div
                    key={`staff-${chatIndex}`}
                    className={`chat-item ${
                      activeChat === chat.user ? "active" : ""
                    }`}
                    onClick={() => {
                      console.log("Chat selected:", chat);
                      handleChatSelect(chat.user, chat.userId);
                    }}
                  >
                    <div className="profile-picture">
                      {chat.profilePicture ? (
                        <img src={chat.profilePicture} alt={chat.user} />
                      ) : (
                        <div className="default-profile-picture"></div>
                      )}
                    </div>
                    <div className="chat-details">
                      <div className="chat-header">
                        <span className="chat-user">{chat.user}</span>
                        {chat.role && (
                          <span
                            className={`chat-role role-${chat.role
                              .toLowerCase()
                              .replace(/\s+/g, "-")}`}
                          >
                            {chat.role}
                          </span>
                        )}
                      </div>
                      <div className="chat-snippet">
                        {getLastMessageSnippet(chat.messages)}
                      </div>
                      <span className="last-message-timestamp">
                        {getLastMessageTimestamp(chat.messages)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Tenants section */}
            {tenantUsers.length > 0 && (
              <div className="user-group">
                <div className="group-label">Tenants</div>
                {tenantUsers.map((chat, chatIndex) => (
                  <div
                    key={`tenant-${chatIndex}`}
                    className={`chat-item ${
                      activeChat === chat.user ? "active" : ""
                    }`}
                    onClick={() => {
                      console.log("Chat selected:", chat);
                      handleChatSelect(chat.user, chat.userId);
                    }}
                  >
                    <div className="profile-picture">
                      {chat.profilePicture ? (
                        <img src={chat.profilePicture} alt={chat.user} />
                      ) : (
                        <div className="default-profile-picture"></div>
                      )}
                    </div>
                    <div className="chat-details">
                      <div className="chat-header">
                        <span className="chat-user">{chat.user}</span>
                        {chat.houseNo && (
                          <span className="chat-house-no">
                            House: {chat.houseNo}
                          </span>
                        )}
                      </div>
                      <div className="chat-snippet">
                        {getLastMessageSnippet(chat.messages)}
                      </div>
                      <span className="last-message-timestamp">
                        {getLastMessageTimestamp(chat.messages)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* No users placeholder */}
            {noUsers.length > 0 && noUsers.map((chat, chatIndex) => (
              <div key={`placeholder-${chatIndex}`} className="chat-item placeholder">
                <div className="chat-details">
                  <div className="chat-header">
                    <span className="chat-no-role-takers">
                      No users in this property
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default OnlineChatList;
